import { render, staticRenderFns } from "./materialInfoCell.vue?vue&type=template&id=1ade3b7c&scoped=true"
import script from "./materialInfoCell.vue?vue&type=script&lang=js"
export * from "./materialInfoCell.vue?vue&type=script&lang=js"
import style0 from "./materialInfoCell.vue?vue&type=style&index=0&id=1ade3b7c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ade3b7c",
  null
  
)

export default component.exports